const COLORS = {
  "text": {
    light:"#313453",
    dark: "#ffffff",
  },
  "off-text": {
    light:"#3134537c",
    dark: "#ffffff7c",
  },
  "text-negative": {
    light:"#ffffff",
    dark: "#000000",
  },
  "background": {
    light:"white",
    dark: "#121212",
  },
  "background-elevated": {
    light:"#f6f6f6",
    dark: "rgba(255,255,255,0.05)",
  },
  "primary": {
    light:"#fceeb0",
    dark: "#2b2238",
  },
  "lighter-primary": {
    light:"#fcf3e4",
    dark: "#413553",
  },
  "darker-primary": {
    light:"#ffa247",
    dark: "#b188fe",
  },
  "gradient-primary": {
    light:"#f8745c",
    dark: "#a1307e",
  },
  "gradient-secondary": {
    light:"#d6456c",
    dark: "#871ec9",
  },
  "gradient-header-primary": {
    light:"#fceeb0",
    dark: "#2b2238",
  },
  "gradient-header-secondary": {
    light:"#fceeb0",
    dark: "#121212",
  },
  "interactive-light": {
    light:"#a923ff",
    dark: "#de4968",
  },
  "interactive-light-50": {
    light:"rgba(169,35,255,0.5)",
    dark: "rgba(222,73,104,0.5)",
  },
  "interactive-dark": {
    light:"#553143",
    dark: "#de4968",
  },
  "heading-inverted": {
    light:"#54137d",
    dark: "#fdde42",
  },
  "text-bold": {
    light:"#d6456c",
    dark: "white",
  }
}

export default COLORS;